(function(global) {
  global.hsTieredDiscount = {
    init: function(config) {
      if (!config || !config.discountedVariantId || !config.fullPriceVariantId) return;

      var maxDiscounted = config.maxDiscounted !== undefined ? config.maxDiscounted : 3;
      var method        = config.method || 'swap'; // 'swap' = Option B, 'cap' = Option C
      var isProcessing  = false;

      function checkCart() {
        if (isProcessing) return;
        fetch('/cart.js')
          .then(function(res) { return res.json(); })
          .then(function(cart) {
            var discountedLines = cart.items.filter(function(item) {
              return item.variant_id === config.discountedVariantId;
            });
            var fullLines = cart.items.filter(function(item) {
              return item.variant_id === config.fullPriceVariantId;
            });

            var discountedQty = discountedLines.reduce(function(sum, i) { return sum + i.quantity; }, 0);
            var fullQty       = fullLines.reduce(function(sum, i) { return sum + i.quantity; }, 0);
            var total         = discountedQty + fullQty;

            if (total === 0) return;

            var targetDiscounted = Math.min(total, maxDiscounted);
            var targetFull       = method === 'swap' ? Math.max(0, total - maxDiscounted) : 0;

            var discountedDiff = targetDiscounted - discountedQty;
            var fullDiff       = targetFull - fullQty;

            if (discountedDiff === 0 && fullDiff === 0) return;

            isProcessing = true;

            // Reductions first to avoid cart conflicts
            var reductions = [];
            if (discountedDiff < 0) reductions = reductions.concat(buildReductions(discountedLines, -discountedDiff));
            if (fullDiff < 0)       reductions = reductions.concat(buildReductions(fullLines, -fullDiff));

            return Promise.all(reductions.map(function(r) {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(r)
              });
            }))
            .then(function() {
              var toAdd = [];
              if (discountedDiff > 0) toAdd.push({ id: config.discountedVariantId, quantity: discountedDiff });
              if (fullDiff > 0)       toAdd.push({ id: config.fullPriceVariantId,  quantity: fullDiff });
              if (!toAdd.length) return;
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: toAdd })
              });
            })
            .then(function() {
              isProcessing = false;
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            })
            .catch(function(err) {
              isProcessing = false;
              console.warn('[hsTieredDiscount] error:', err);
            });
          })
          .catch(function(err) {
            console.warn('[hsTieredDiscount] error:', err);
          });
      }

      function buildReductions(lines, amount) {
        var remaining = amount;
        var updates = [];
        lines.forEach(function(line) {
          if (remaining <= 0) return;
          var reduce = Math.min(line.quantity, remaining);
          remaining -= reduce;
          updates.push({ id: line.key, quantity: line.quantity - reduce });
        });
        return updates;
      }

      checkCart();
      document.addEventListener('cart:refresh', checkCart);
      document.addEventListener('cart:updated', checkCart);
    }
  };
})(window);
